import { Box, Tab, Tabs } from "@mui/material";

export type FileTabValue = "all" | "uploaded-by-me" | "uploaded-by-others";

interface FileTabsProps {
  value: FileTabValue;
  onChange: (value: FileTabValue) => void;
}

/**
 * Tab filters for file management
 * Matches Figma design with grey background and white active state
 */
export default function FileTabs({ value, onChange }: FileTabsProps) {
  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: FileTabValue
  ) => {
    onChange(newValue);
  };

  return (
    <Box
      sx={{
        backgroundColor: "var(--base/muted, #f4f4f5)",
        borderRadius: "6px",
        padding: "4px",
        display: "inline-flex",
        height: "40px",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          minHeight: "32px",
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTab-root": {
            minHeight: "32px",
            padding: "6px 12px",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "none",
            color: "var(--base/muted-foreground, #71717a)",
            borderRadius: "4px",
            transition: "all 0.2s",
            "&.Mui-selected": {
              backgroundColor: "white !important",
              color: "var(--base/foreground, #18181b) !important",
              boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.1)",
              fontWeight: 600,
            },
          },
        }}
      >
        <Tab label="All" value="all" />
        <Tab label="My files" value="uploaded-by-me" />
        <Tab label="Someone else's files" value="uploaded-by-others" />
      </Tabs>
    </Box>
  );
}
